module.exports = __webpack_public_path__ + "img/navigation-right.ca0f6449.svg";